<h1 class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Ośrodki szkolenia kierowców</h1>
<div class="osk-card fill-column">
  <div class="osk-toolbar">
    <label class="osk-checkbox">
      <input type="checkbox" [(ngModel)]="onlyPendingApproval" (change)="resetAndLoad()">
      Tylko OSK do akceptacji
    </label>
    <span class="osk-search border-solid border-round-md border-1 p-1 border-300 flex align-items-center">
      <i class="pi pi-search mr-2 text-primary" aria-hidden="true"></i>
      <input #searchInput pInputText type="search" placeholder="Wyszukaj" aria-label="Wyszukaj OSK"
        class="p-1 border-none outline-none text-base w-full"
        (input)="onSearch(searchInput.value)">
    </span>
    <p-button icon="pi pi-plus" label="Dodaj OSK" (onClick)="addNewOsk()" data-clarity-unmask="true"></p-button>
  </div>
  <fas-services-table class="table-height" styleClass="osk-table" scrollHeight="flex" [value]="oskList" [columns]="oskColumns"
    [rows]="rows" [first]="first" [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [alwaysShowPaginator]="false"
    [showCheckbox]="false" [showEmptyColumn]="false" [loading]="loading" [lazy]="true"
    [totalRecords]="totalRecords" [footerButtonOptions]="null" [showFooterPageReport]="false" (lazyLoad)="load($event)">
    <ng-template #oskNameTemplate let-row let-rowIndex="rowIndex">
      <div class="osk-name-cell">
        <span>{{ row.oskShortCode }}</span>
        <span *ngIf="row.isPendingApproval" class="osk-pending" pTooltip="OSK oczekuje na akceptację">
          <i class="pi pi-clock" aria-hidden="true"></i> OSK
        </span>
        <button type="button" class="white-button appear" (click)="showDetails(row, rowIndex)" data-clarity-unmask="true">
          Szczegóły <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </button>
        <button *ngIf="row.isPendingApproval" type="button" class="primary-button appear"
          (click)="approveOsk(row)" data-clarity-unmask="true">
          Akceptuj <i class="pi pi-check" aria-hidden="true"></i>
        </button>
      </div>
    </ng-template>
    <ng-template #contactTemplate let-row>
      <div class="flex flex-column gap-2 p-2">
        <div *ngIf="row.oskEmail">
          <i class="pi pi-envelope"></i> {{ row.oskEmail }}
        </div>
        <div *ngIf="row.oskPhones">
          <div *ngFor="let phone of row.oskPhones.split(';')">
            <i class="pi pi-phone"></i> {{ phone.trim() }}
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template #subscriptionsListTemplate let-row>
      <div class="flex gap-2 flex-wrap m-2">
        <app-subscription-tag
          *ngFor="let sub of row.oskPlatformSubscriptionPlans"
          [bgColor]="sub.bgColor ?? ''"
          [fgColor]="sub.fgColor ?? ''"
          [planName]="sub.planName ?? ''"
          [available]="sub.available"
        ></app-subscription-tag>
      </div>
    </ng-template>
  </fas-services-table>

  <app-osk-details
    [data]="osk"
    [dataList]="oskList"
    [dataIndex]="oskIndex"
    [ID_dialog]="ID_OSK"
    (oskUpdated)="load()"
  >
  </app-osk-details>
</div>
